<template>
    <notifications width="33%" classes="app-notification"/>
    <router-view :key="$route.path"/>
</template>

<script setup>
import axios from 'axios';

import { userStore } from '@/store/user'
import { clientStore } from '@/store/client'
import { appStore } from '@/store/app'
import { useRouter } from 'vue-router'
import { onMounted } from 'vue';

const user = userStore();
const router = useRouter();
const app = appStore();
const client = clientStore();

router.beforeEach((to, from) => {
    if (!user?.isLoggedIn && to.fullPath !== "/login") {
        router.push("/login");
        return false;
    }
    return true;
});

axios.interceptors.response.use(function (response) { return response }, function (error) {
    if (error.response.status == 401) {
        console.warn("intercepted", error)
        user.logout()
        router.push('/login')
    }
    return Promise.reject(error)
})

onMounted(() => {
    const savedToken = user.load();
    if (savedToken) {
        app.setToken(savedToken);
        client.getProperties();
    }
});
</script>

<style lang="scss">

</style>
